import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: 'zh',
    supportedLngs: ['zh', 'en'],
    fallbackLng: { zh: ['en'], default: ['en'] },
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    debug: false,
    resources: messages,
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;